<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="省份" prop="provinceCode">
        <el-select
          v-model="search.provinceCode"
          placeholder="请选择"
          clearable
          style="width: 100%"
          @change="getTblCity"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.provinceCode"
            :label="item.provinceName"
            :value="item.provinceCode"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="城市" prop="cityCode">
        <el-select
          v-model="search.cityCode"
          placeholder="请选择"
          clearable
          style="width: 100%"
          :disabled="!search.provinceCode"
        >
          <el-option
            v-for="item in cityList"
            :key="item.cityCode"
            :label="item.cityName"
            :value="item.cityCode"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="等级" prop="cityLevel">
        <el-select
          v-model="search.cityLevel"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in cityLevelList"
            :key="item"
            :label="item"
            :value="item"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="row-bg">
      <el-button type="primary" size="medium" @click="handleSearch()"
        >查询</el-button
      >
      <el-button size="medium" @click="resetForm">重置</el-button>
    </div>

    <el-table
      ref="checktableData"
      :data="list"
      v-loading="listLoading"
      :reserve-selection="true"
      center
      height="60vh"
    >
      <el-table-column label="地区编号" prop="cityCode"></el-table-column>
      <el-table-column label="省份" prop="provinceName"> </el-table-column>
      <el-table-column label="城市" prop="cityName"></el-table-column>
      <el-table-column label="等级" prop="cityLevel"></el-table-column>
      <el-table-column label="等级规则" prop="cityLevelDesc"></el-table-column>
      <el-table-column
        label="刷新时间"
        prop="lastModifiedDate"
      ></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.pageNum"
        :page-size="search.pageSize"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { pageCondition, findAllProvince, findAllCity, getCityLevelEnum } from "@/api/oldForNew";

export default {
  name: "order",

  data() {
    return {
      list: [],
      total: null, //列表总条数
      listLoading: false,
      search: {
        provinceCode: null, //省
        cityCode: null, //市
        cityLevel: null, //等级
        pageNum: 1, //当前页
        pageSize: 10,
      },
      provinceList: [], //省份列表
      cityList: [], //市列表
      cityLevelList: [], //等级列表
    };
  },
  async created() {
    this.getList();
    this.getTblProvince();
    this.getCityLevel();
  },
  methods: {
    async handleSearch() {
      this.search.pageNum = 1;
      this.getList();
    },
    async getList() {
      let {
        statusCode,
        data,
        total,
        message,
      } = await pageCondition(this.search);
      if (statusCode == 200) {
        this.list = data || [];
        this.total = total || 0;
      } else {
        this.$message.error(message);
      }
    },
    //获取省份列表
    async getTblProvince() {
      this.search.cityCode = "";

      let { statusCode, data } = await findAllProvince();
      if (statusCode === 200) {
        this.provinceList = data;
      }
    },
    //根据省份获取城市列表
    async getTblCity() {
      this.search.cityCode = "";
      if (!this.search.provinceCode) {
        return;
      }
      let { statusCode, data } = await findAllCity(
        this.search.provinceCode
      );
      if (statusCode === 200) {
        this.cityList = data;
      }
    },
    // 获取城市等级
    async getCityLevel() {
      let { statusCode, data } = await getCityLevelEnum();
      if (statusCode === 200) {
        this.cityLevelList = data;
      }
    },

    handleSizeChange(val) {
      this.search.pageNum = 1;
      this.search.pageSize = val;
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },
    resetForm() {
      this.search = this.$options.data().search;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.row-bg {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/cityGrade.vue